import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import Footer from './Footer';
import Navbar from './Navbar';

const Contact = () => {
  const form = useRef();
  
  // State for managing alert visibility and message
  const [alertMessage, setAlertMessage] = useState('');
  const [alertType, setAlertType] = useState(''); // 'success' or 'error'
  const [isFormSent, setIsFormSent] = useState(false); // State to disable the form after sending

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm('service_yw7lpbq', 'template_4fnzuvw', form.current, {
        publicKey: 'IsywhZrX5_2nwhrWU',
      })
      .then(
        () => {
          console.log('SUCCESS!');
          setAlertMessage('Your message has been sent successfully!'); // Success message
          setAlertType('success'); // Success alert type
          setIsFormSent(true); // Disable the form after successful submission
          form.current.reset(); // Reset form fields
        },
        (error) => {
          console.log('FAILED...', error.text);
          setAlertMessage('Failed to send message. Please try again later.'); // Error message
          setAlertType('error'); // Error alert type
        }
      );
  };

  return (
    <>
      <Navbar/>
      <div className="w-full py-16 px-6 bg-blue-100  m-0 ">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center">
          <div className="md:w-1/2">
            <img
              src="https://i.pinimg.com/736x/df/d2/69/dfd26984ff80a2995103923e3a1e9264.jpg"
              alt="Quran"
              className="w-full h-full object-cover"
            />
          </div>

          <div className="md:w-1/2 p-10">
            <h2 className="text-3xl  text-blue-700 mb-4 font-serif ">Contact Us</h2>
            <div className="w-24 h-1 bg-blue-700 mb-6"></div>
            <p className="text-gray-700 text-sm md:text-base leading-relaxed  max-w-2xl mx-auto mb-8 text-left ">
              If you would like to support <span className="font-semibold">The Quran Explained</span> project or have any inquiries, feel free to reach out to us.
            </p>
            

            {/* Displaying the alert message */}
            {alertMessage && (
              <div
                className={`p-4 mb-6 rounded-lg ${
                  alertType === 'success'
                    ? 'bg-green-500 text-white'
                    : 'bg-red-500 text-white'
                }`}
              >
                {alertMessage}
              </div>
            )}

            {/* Display form or message based on the form submission */}
            {!isFormSent ? (
              <form ref={form} onSubmit={sendEmail} className="space-y-6 text-left">
                <div>
                  <label className="block text-gray-700 text-lg ">Name</label>
                  <input
                    type="text"
                    name="user_name"
                    required
                    className="w-full p-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-700 text-lg bg-transparent"
                  />
                </div>

                <div>
                  <label className="block text-gray-700 text-lg ">Email</label>
                  <input
                    type="email"
                    name="user_email"
                    required
                    className="w-full p-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-700 text-lg bg-transparent"
                  />
                </div>

                <div>
                  <label className="block text-gray-700 text-lg ">Message</label>
                  <textarea
                    name="message"
                    required
                    rows="4"
                    className="w-full p-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-700 text-lg bg-transparent"
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="w-full bg-blue-700 text-white py-4 rounded-full text-xl  hover:bg-blue-800 transition duration-300"
                >
                  Send Message
                </button>
              </form>
            ) : (
              <div className="text-center text-lg font-medium text-gray-700">
                <p>Thank you for contacting us! We'll get back to you soon.</p>
              </div>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Contact;
